import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View, } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles'
import useStyles from "./LoginFooter_Styles";
const isSmallDevice = Dimensions.get('window').width < 767

export default function LoginFooter(props) {
    const styles = useStyles();


    return (
        <View>
            <View style={styles.footerContainerStyle}>
                <View style={styles.footerFirstViewStyle}>
                    <Text style={styles.contactUsTextStyle}>{"Contact Us"}</Text>
                    <Text style={styles.idfcBankTextStyle}>
                        {"IDFC FIRST Bank Limited"}
                    </Text>
                    <Text style={styles.helpLineTextStyle}>
                        {"Customer Helpline - 1800 266 9970"}
                    </Text>
                    <Image
                        source={require("../../assets/images/rectangle53.png")}
                        style={styles.npciImageStyle}
                    />
                </View>
                <View style={styles.footerSecondViewStyle}>
                    <Text style={styles.ffBenefitsTextStyle}>
                        {"One FASTag, Three Payments : Toll, Fuel and Parking"}
                    </Text>
                    <Text style={styles.benefitsDescTextStyle}>
                        {`Breeze through long lines at toll plazas with IDFC FIRST Bank FASTag – Firstforward. It’s a simple, reloadable tag, which is affixed to the inside of your car’s windscreen, enabling you to pay for tolls, parking, and more automatically. With IDFC FIRST Bank FIRSTforward, you can keep track of all your spends on FASTag, like Toll, parking & Fuel payment etc.`}
                    </Text>
                </View>
            </View>
        </View>

    );
}



